import _get from 'lodash/get';
import * as userGroupsActions from './actions';
import { RootState } from './types';

// Compare prev and current props and return the appropriate action
// prev and current props must contain auth state object
export const getActionFromPropsUpdate = (prevProps: RootState, currentProps: RootState) => {
  const { auth: prevAuth } = prevProps;
  const { auth } = currentProps;
  const isAuthorized = _get(auth, 'data.auth', false);
  const isPrevAuthorized = _get(prevAuth, 'data.auth', false);
  if (isPrevAuthorized !== isAuthorized) {
    return isAuthorized ? userGroupsActions.getUserGroups : userGroupsActions.resetUserGroups;
  }

  return null;
};
